import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { mergeStyles } from 'office-ui-fabric-react';
import { ThemeProvider } from '@fluentui/react-theme-provider';

import AppRouter from './components/AppRouter';
import configureStore from './store';

mergeStyles({
    selectors: {
        ':global(body), :global(html), :global(#root)': {
            margin: 0,
            padding: 0,
            height: '100vh'
        },
        ':global(body)': {
            //overflow: 'hidden'
        },
        ':global(::-webkit-scrollbar)': {
            width: '8px',
        },
        ':global(::-webkit-scrollbar-track)': {
            background: '#ffffff'
        },
        ':global(::-webkit-scrollbar-thumb)': {
            borderRadius: '0px',
            background: '#dddddd'
        },
        ':global(::-webkit-scrollbar-thumb:hover)': {
            background: '#999999'
        }
    }
});

const appTheme = {
    palette: {
    },

    semanticColors: {
        bodyBackground: 'auto'
    },

    fonts: {
        small: {
            fontSize: '14px'
        },

        smallB: {
            fontSize: '16px',
            fontWeight: 'bold'
        },

        medium: {
            fontSize: '16px',
        },

        mediumB: {
            fontSize: '18px',
            fontWeight: 'bold'
        },

        large: {
            fontSize: '20px',
            fontWeight: 'bold'
        },
        xLarge: {
            fontSize: '24px',
            fontWeight: 'bold'
        },
        xxLarge: {
            fontSize: '30px',
            fontWeight: 'bold'
        },
        xxxLarge: {
            fontSize: '48px',
            fontWeight: 'bold'
        }
    }
};

document.title = 'Kalkulátor mezí';

ReactDOM.render(
    <Provider store={configureStore()}>
        <ThemeProvider theme={appTheme}>
            <AppRouter />
        </ThemeProvider>
    </Provider>,
    document.getElementById('root')
);
